// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"oVc6167","gigAttributeWrapper":"oVc6167","gig-attribute":"FwGjhfv","gigAttribute":"FwGjhfv","attribute-text":"W4QVQCN","attributeText":"W4QVQCN"};